import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';

interface IMatterParameters {
  parametersToGet?: string[];
  enabled?: boolean;
  matterId?: string;
}
export const useFetchMatterParameters = (params: IMatterParameters) => {
  const { enabled = false, matterId, ...rest } = params;
  const queryString = toQueryString(rest as unknown as QueryParamObject);
  const urlWithId = `${API_URLS.MATTER_PARAMETERS.replace(':id', matterId ?? '')}`;
  const url = queryString ? `${urlWithId}?${queryString}` : urlWithId;
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['matter-parameters', matterId, rest],
    queryFn: () => {
      return get(url);
    },
    enabled: !!enabled,
  });

  return { data: error ? undefined : (data ?? null), isLoading, error, refetch };
};
